import {
  SET_CARD_TYPE,
  CLEAR_CARD_TYPE,
} from '../../../constants/actionConstants';

export const clearCardType = () => ({
  type: CLEAR_CARD_TYPE,
});

export const getCardType = cardNumber => async (dispatch, getState) => {
  const creditCardTypes = getState().config?.creditCardTypes ?? [];

  const foundCardType = creditCardTypes?.find((item) => {
    const pattern = new RegExp(item.pattern);
    return pattern.test(cardNumber?.replace(/ /g, ''));
  }) || false;

  if (!foundCardType) {
    dispatch(clearCardType());
  } else {
    dispatch({
      type: SET_CARD_TYPE,
      cardType: foundCardType,
    });
  }
};
